import { inject, Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { merge, Observable, Subject } from 'rxjs';
import { settingsStoreToken } from '../../cross-team-shared/state/setting-state';
import { PointCloudContentStore } from '../state/point-cloud-content-store';
import { GlobalRenderTriggerService } from './global-render-trigger.service';

@Injectable()
export class RenderTriggerService extends InjectableSuperclass {
  readonly trigger$ = new Subject<void>();

  private nonStoreChanges$ = new Subject<void>();
  private localTriggers$: Array<Observable<any>> = [];
  private globalTrigger$ = inject(GlobalRenderTriggerService).trigger$;
  private store = inject(PointCloudContentStore);
  private settingStore = inject(settingsStoreToken);

  constructor() {
    super();
    this.subscribeToRenderTriggers();
  }

  addTrigger(trigger$: Observable<any>) {
    this.localTriggers$.push(trigger$);
    this.subscribeToRenderTriggers();
  }

  trigger() {
    this.nonStoreChanges$.next();
  }

  private subscribeToRenderTriggers() {
    this.unsubscribe();
    this.subscribeTo(
      merge(
        ...this.localTriggers$,
        this.globalTrigger$,
        this.nonStoreChanges$,
        this.store('render').$,
        this.settingStore.$,
      ),
      () => {
        this.trigger$.next();
      },
    );
  }
}
